import { render, staticRenderFns } from "./mark-follow.vue?vue&type=template&id=5c9bf778&"
import script from "./mark-follow.vue?vue&type=script&lang=js&"
export * from "./mark-follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports